module.exports = __webpack_public_path__ + "static/media/icon_career.d545dc4e.svg";